module.exports = __webpack_public_path__ + "images/backgrounds/page-hero.png";